import {
	Archive,
	Dumbbell,
	Home,
	Image,
	LogOut,
	NotebookTabs,
	X,
} from 'lucide-react'
import { NavLink } from 'react-router-dom'

import { Button } from '@/components/ui/button'
import { useAuth } from '@app/auth/auth-context'
import { routeOperations } from '@app/auth/permissions'
import type { AdminOperationId } from '@shared/api'

const links: Array<{
	to: string
	label: string
	icon: typeof Home
	exact?: boolean
	operation: AdminOperationId
}> = [
	{ to: '/', label: 'Главная', icon: Home, exact: true, operation: routeOperations.dashboard },
	{ to: '/exercises', label: 'Упражнения', icon: Dumbbell, operation: routeOperations.exercises },
	{ to: '/programs', label: 'Программы', icon: NotebookTabs, operation: routeOperations.programs },
	{ to: '/media', label: 'Медиатека', icon: Image, operation: routeOperations.media },
	{ to: '/archive', label: 'Архив', icon: Archive, operation: routeOperations.archive },
]

export const Sidebar = ({ mobile = false, onNavigate }: { mobile?: boolean; onNavigate?: () => void }) => {
	const { principal, logout, can } = useAuth()
	const availableLinks = links.filter(link => can(link.operation))
	return (
		<aside
			aria-label='Основная навигация'
			className={
				mobile
					? 'flex h-full w-72 flex-col border-r bg-background p-4 shadow-xl'
					: 'fixed inset-y-0 left-0 z-20 hidden w-64 flex-col border-r bg-background p-4 lg:flex'
			}>
			<div className='mb-8 flex items-start justify-between px-2'>
				<div className='min-w-0'>
					<div className='text-lg font-semibold'>TISIT Admin</div>
					<div className='mt-1 truncate text-xs text-muted-foreground'>
						{principal?.username ?? principal?.subject ?? 'Не авторизован'}
					</div>
				</div>
				{mobile ? (
					<Button variant='ghost' size='icon' onClick={onNavigate} aria-label='Закрыть меню'>
						<X className='h-4 w-4' />
					</Button>
				) : null}
			</div>
			<nav className='flex flex-1 flex-col gap-1'>
				{availableLinks.map(({ to, label, icon: Icon, exact }) => (
					<NavLink
						key={to}
						to={to}
						exact={exact}
						onClick={onNavigate}
						activeClassName='bg-accent text-accent-foreground font-medium'
						className='flex items-center gap-3 rounded-md px-3 py-2 text-sm text-muted-foreground transition-colors hover:bg-accent hover:text-accent-foreground'>
						<Icon className='h-4 w-4' aria-hidden='true' />
						<span>{label}</span>
					</NavLink>
				))}
			</nav>
			<div className='space-y-3 border-t pt-4'>
				<div className='px-3 text-xs text-muted-foreground'>
					{principal?.roles.join(', ') || 'Нет назначенных ролей'}
				</div>
				<Button
					variant='outline'
					className='w-full justify-start gap-3'
					onClick={() => void logout()}>
					<LogOut className='h-4 w-4' />
					Выйти
				</Button>
			</div>
		</aside>
	)
}
